const FORWARD_BUTTON_TYPES = {
  SKIP: 'skip',
  NEXT: 'next',
  HIDDEN: 'hidden',
  DONE: 'done',
  SAVE: 'save',
}

export default FORWARD_BUTTON_TYPES
